



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import VideoPlayer from '@/video/player/components/VideoPlayer.vue';
import PlayIcon from '../assets/play.svg';

@Component({
  components: {
    VideoPlayer,
    PlayIcon,
  },
})
export default class DocumentHeader extends Vue {
  @Prop() name!: string;
  @Prop() expirationDate!: string;
  @Prop() videoThumbnail?: string;
  @Prop() videoUrl?: string;
  @Prop() reminderExpirationDays: number;
  @Prop() isSigned: boolean;
  @Prop() signDate: string;
  @Prop({ default: true }) showExpiration?: boolean;

  time: moment.Moment = moment.utc();
  intervalTimer;

  @Watch('isSigned')
  watchIsSigned() {
    this.time = moment().utc();
  }

  get documentStatusInformationText(): string {
    return this.isSigned ? this.signedText : this.expirationText;
  }

  get signedText(): string {
    const timeAgo: string = moment.utc(this.signDate).from(this.time);
    return `${this.$t('signed')} ${timeAgo}`;
  }

  get expirationText(): string {
    const timeTo: string = moment.utc(this.expirationDate).from(this.time);
    const expired: boolean = moment.utc(this.expirationDate).diff(this.time) < 0;
    return expired ? `${this.$t('expired')} ${timeTo}` : `${this.$t('expires')} ${timeTo}`;
  }

  get expirationWarning(): boolean {
    if (this.isSigned) {
      return false;
    }
    const diff: number = moment.utc(this.expirationDate).diff(this.time, 'days');

    return diff < this.reminderExpirationDays;
  }

  handleClick() {
    this.$emit('videoIntro');
  }

  mounted() {
    this.intervalTimer = setInterval(() => {
      this.time = moment().utc();
    }, 60000);
  }

  beforeDestroy() {
    clearInterval(this.intervalTimer);
  }
}
